"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var index_1 = require("../../index");
var Type;
(function (Type) {
    Type["Destructive"] = "oui-table__action-destructive";
})(Type = exports.Type || (exports.Type = {}));
var Action = function (_a) {
    var _b;
    var onClick = _a.onClick, disabled = _a.disabled, type = _a.type, children = _a.children, testId = _a.testId;
    return (React.createElement("div", { className: classNames("oui-table__action", (_b = {}, _b[type] = !!type, _b)) }, typeof children === "string"
        ? (React.createElement(index_1.Button, { onClick: onClick, disabled: disabled, testId: testId }, children)) : children));
};
exports.default = Action;
//# sourceMappingURL=Action.js.map